import { LeaseType, ListingStatus } from "types/globalTypes";

interface IListing {
  leaseType: LeaseType | null;
  accurateMonthlyPrice: number | null;
  accuratePsf: number | null;
  estimatedMonthlyPrice: string | null;
  estimatedPsf: number | null;
  displayMonthlyPrice: string | null;
  displayPSF: string | null;
  status: ListingStatus | null;
}

const renderPricing = (
  {
    leaseType,
    accurateMonthlyPrice,
    accuratePsf,
    estimatedMonthlyPrice,
    estimatedPsf,
    displayMonthlyPrice,
    displayPSF,
    status,
  }: IListing,
  maxMonthlyPrice: number,
  maxPricePerSquareFoot: number
) => {
  const nonNullEstimatedMonthlyPrice = estimatedMonthlyPrice || "0";
  const estimatedMonthlyPriceAsNum = parseInt(nonNullEstimatedMonthlyPrice, 10);
  if (status === "UNAVAILABLE")
    return <span className="caption">Inquire for Pricing</span>;
  const isAccuratePricingInfoPresent = !!accurateMonthlyPrice && !!accuratePsf;
  const hasEstimatedPricing = !!estimatedMonthlyPriceAsNum && !!estimatedPsf;

  const isEstimatedPricingInfoOutsideSearchBounds =
    (estimatedPsf || 0) > maxPricePerSquareFoot ||
    (estimatedMonthlyPriceAsNum || 0) > maxMonthlyPrice;

  if (leaseType === "DIRECT") {
    if (isAccuratePricingInfoPresent) {
      return (
        <>
          <span>{displayMonthlyPrice}/mo</span>
          <span> ({displayPSF} psf)</span>
        </>
      );
    }
    if (hasEstimatedPricing && !isEstimatedPricingInfoOutsideSearchBounds) {
      return (
        <>
          <span>{displayMonthlyPrice}/mo</span>
          <span> ({displayPSF} psf)</span>
        </>
      );
    }
  }

  if (leaseType === "SUBLEASE") {
    if (isAccuratePricingInfoPresent) {
      return (
        <>
          <span>{displayMonthlyPrice}/mo</span>
          <span> ({displayPSF} psf)</span>
        </>
      );
    }
  }
  if (leaseType === "LICENSE_AGREEMENT" && accurateMonthlyPrice) {
    return <span>{displayMonthlyPrice}/mo</span>;
  }
  return <span className="caption">Inquire for Pricing</span>;
};

export default renderPricing;
